module.exports = __webpack_public_path__ + "assets/img/student_img.a65c0b46.png";